// AI Generated file
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'generateUrlParams',
    standalone: false,
})
export class GenerateUrlParamsPipe implements PipeTransform {
    transform (params: { [key: string]: any }): string {
        const result: string[] = [];
        for (const param in params) {
            if (params.hasOwnProperty(param)) {
                result.push(param + '=' + params[param]);
            }
        }
        return '?' + result.join('&');
    }
}
